export const CREATE_ITINERARY = `
  mutation CreateItinerary($input: ItineraryInput!) {
    createItinerary(input: $input) {
      sessionId
      status
    }
  }
`;

export const GET_ITINERARY = `
  query GetItinerary($sessionId: ID!) {
    getItinerary(sessionId: $sessionId) {
      sessionId
      status
      itinerary {
        title
        summary
        flightDetails { departure arrival suggestedFlight }
        accommodationDetails { name type description }
        days {
          day
          theme
          activities { time activity description location cost maps_url thumbnail place_id }
        }
        costBreakdown { category amount }
        tips
      }
      postcardS3Uri
      postcardUrl
      pdfUrl
    }
  }
`;

export const SUBMIT_SURVEY = `
  mutation SubmitSurvey($input: SurveyInput!) {
    submitSurvey(input: $input) {
      success
      message
      postcardUrl
      email
    }
  }
`;

export const SEND_CHAT = `
  mutation SendChat($input: ItineraryInput!) {
    createItinerary(input: $input) {
      sessionId
      status
    }
  }
`;

export const ON_AGENT_UPDATE = `
  subscription OnAgentUpdate($sessionId: ID!) {
    onAgentUpdate(sessionId: $sessionId) {
      sessionId
      eventType
      message
      toolName
      modelName
      data
      timestamp
    }
  }
`;

export const ON_ITINERARY_UPDATE = `
  subscription OnItineraryUpdate($sessionId: ID!) {
    onItineraryUpdate(sessionId: $sessionId) {
      sessionId
      status
      postcardUrl
      pdfUrl
    }
  }
`;
